var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.0668H27M25.3077 5H6.69231C6.24348 5 5.81303 5.1783 5.49567 5.49567C5.1783 5.81303 5 6.24348 5 6.69231V25.3077C5 25.7565 5.1783 26.187 5.49567 26.5043C5.81303 26.8217 6.24348 27 6.69231 27H25.3077C25.7565 27 26.187 26.8217 26.5043 26.5043C26.8217 26.187 27 25.7565 27 25.3077V6.69231C27 6.24348 26.8217 5.81303 26.5043 5.49567C26.187 5.1783 25.7565 5 25.3077 5Z",
    stroke: "#333333",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5935 22.1312L12.408 14.9457M16.0008 23.6154C16.6675 23.6154 17.3276 23.4841 17.9436 23.2289C18.5596 22.9738 19.1192 22.5998 19.5907 22.1284C20.0621 21.657 20.4361 21.0973 20.6912 20.4813C20.9464 19.8654 21.0777 19.2052 21.0777 18.5385C21.0777 17.8718 20.9464 17.2116 20.6912 16.5956C20.4361 15.9797 20.0621 15.42 19.5907 14.9485C19.1192 14.4771 18.5596 14.1031 17.9436 13.848C17.3276 13.5929 16.6675 13.4615 16.0008 13.4615C14.6543 13.4615 13.3629 13.9964 12.4108 14.9485C11.4587 15.9007 10.9238 17.192 10.9238 18.5385C10.9238 19.885 11.4587 21.1763 12.4108 22.1284C13.3629 23.0805 14.6543 23.6154 16.0008 23.6154Z",
    stroke: "#333333",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionIcon);
export default __webpack_public_path__ + "static/media/permission-icon.fd3353fe94ffdc700e6ab08c3f18062a.svg";
export { ForwardRef as ReactComponent };